import {
  IComponents as IGcfComponents,
  IProducts as IGcfProducts,
} from 'gcf-components/interfaces';

import { IThemes } from './GCFThemes';
import { ProjectConfigInterface } from './ProjectConfig';
import { IScreen } from './Screen';

export enum FileTypes {
  CONTENTS = 'contents',
  PRODUCTS = 'products',
  ASSETS = 'assets',
  OVERRIDES = 'overrides',
  CONFIGS = 'configs',
  DAYPARTS = 'dayparts',
  LOCATION = 'location',
  COMPONENTS = 'components',
  TEMPLATES = 'templates',
  TEMPLATE_VARIATIONS = 'template-variations',
  /** @deprecated For legacy cc publication v1 */
  FULL = 'full',
}

export const CREATIVE_CENTER = 'creative-center';

export enum FileNames {
  PRODUCTS = `${CREATIVE_CENTER}-${FileTypes.PRODUCTS}`,
  ASSETS = `${CREATIVE_CENTER}-${FileTypes.ASSETS}`,
  CONTENTS = `${CREATIVE_CENTER}-${FileTypes.CONTENTS}`,
  CONFIGS = `${CREATIVE_CENTER}-${FileTypes.CONFIGS}`,
  OVERRIDES = `${CREATIVE_CENTER}-${FileTypes.OVERRIDES}`,
  DAYPARTS = `${CREATIVE_CENTER}-${FileTypes.DAYPARTS}`,
  LOCATION = `${CREATIVE_CENTER}-${FileTypes.LOCATION}`,
  COMPONENTS = `${CREATIVE_CENTER}-${FileTypes.COMPONENTS}`,
  TEMPLATES = `${CREATIVE_CENTER}-${FileTypes.TEMPLATES}`,
  TEMPLATE_VARIATIONS = `${CREATIVE_CENTER}-${FileTypes.TEMPLATE_VARIATIONS}`,
}

export interface IVersion {
  version_id: string;
  timestamp: string; // 2023-12-07T01:22:04.000Z
}

export interface ILocationFileVersion extends IVersion {
  type: FileTypes;
}

export interface IRBHistory {
  locationTimezone: string;
  versions: IVersion[];
}

export interface ILocationHistory {
  locationTimezone: string;
  versions: Record<string, ILocationFileVersion[]>;
}

export interface ILocations {
  channels: IChannels;
}

export interface IContents {
  /** @deprecated moved outside of contents since R28 */
  components?: Record<string, IGcfComponents>;
  assemblies: ILocationAssembly;
  screens: Record<string, IScreen>;
}
export interface IConfigs {
  projectConfig: ProjectConfigInterface;
  themes: IThemes;
}

export interface ILocationData extends IContents, IConfigs {
  products: IGcfProducts;
  location: ILocations;
}

export interface IRBData {
  restaurantID: number;
  currency: {
    decimalDigits: number;
    decimalSeparator: string;
    symbol: string;
    thousandSeparator: string;
  };
  productOutages: number[];
  products: IRBProduct[];
}

export interface ILocationDaypart {
  name: string;
  startTime: string;
  assemblies: IDaypartAssembly[];
}

export enum Weekdays {
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
  SUNDAY = 'Sunday',
}

export type IDays = {
  [key in Weekdays]: string | null;
};

export interface IDaypartAssembly {
  id: number;
  assemblyId: number;
  startDate: string;
  endDate: string | null;
  config?: any;
  createdAt?: string;
  modifiedAt?: string;
  overrides?: IDaypartAssemblyOverride[];
}

interface IChannels {
  [key: string]: {
    dayparts: ILocationDaypart[];
  };
}

interface KeyObject {
  [key: string]: any;
}

interface IRBProduct {
  id: number | string;
  type: string;
  price: number;
  outage: boolean;
  minEnergy: number;
  maxEnergy: number;
  name: KeyObject;
  size: KeyObject;
  nameWithSize: KeyObject;
  image: KeyObject;
}

interface IDaypartAssemblyOverride {
  id: number;
  assemblyComponentId: number;
  componentId: number;
  overrideProducts: boolean;
  startDate: string;
  endDate: string | null;
  active: boolean;
  createdAt?: string;
  modifiedAt?: string;
  productCodes?: string[];
}

export interface ILocationAssembly {
  [key: string]: {
    id: number;
    name: string;
  };
}
